import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  Grid,
  Box,
  Button,
  Stack,
  CircularProgress,
} from "@mui/material";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import { FieldTextField } from "../../../../components/selections/fieldInputs";
import { qrDialogPaperSx, QrModalHeader } from "../../../qrCode/components/qrUi";
import { stepActionsSx, nextBtnSx, backBtnSx } from "../../../campaign/components/stepUi";
import Slide from "@mui/material/Slide";
import { useDispatch, useSelector } from "react-redux";
import SnackbarMessage from "../../../../components/snackBar/snackBar";
import EditIcon from '@mui/icons-material/Edit';
import { updateTagThunk, getTagsThunk } from "../../../contact/contactThunk";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function EditTagModal({ show, handleClose, rowData }) {

  const dispatch = useDispatch();
  const { status2, error } = useSelector((state) => state.contacts);

  const [tagName, setTagName] = useState("");
  const [changedFields, setChangedFields] = useState(new Set());
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  
  useEffect(() => {
    setTagName(rowData?.tag_name ? rowData.tag_name.trim() : "");
  }, [rowData?.tag_name]);


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!tagName.trim()) {
      setSnackbar({
        open: true,
        message: "Tag Name is required",
        severity: "error",
      });
      return;
    }

    if (!changedFields || changedFields.size === 0) {
      setSnackbar({
        open: true,
        message: "No changes to update",
        severity: "info",
      });
      setTimeout(() => {
        handleClose();
      }, 1000);
      return;
    } else {
      const payload = {};

      if (changedFields.has("tagName")) {
        payload.tag_name = tagName;
      }

      try {
        const result = await dispatch(
          updateTagThunk({
            credentials: {
              tag_name: tagName.trim(),
              "tag_id": rowData?.id,
              "action": "update"
            }
          })
        );

        if (result.meta.requestStatus === "fulfilled") {
          setSnackbar({
            open: true,
            message: result.payload.message,
            severity: "success",
          });

          await dispatch(getTagsThunk({ type: "tags" }));
          handleClose();
          setTagName("");
          setChangedFields(new Set());
        } else {
          setSnackbar({
            open: true,
            message: result.payload,
            severity: "error",
          });
        }
      } catch {
        setSnackbar({
          open: true,
          message: "Server error. Please try again.",
          severity: "error",
        });
      }
    }
  }

  return (
    <Dialog
      open={show}
      onClose={handleClose}
      TransitionComponent={Transition}
      fullWidth
      maxWidth="xs"
      keepMounted
      PaperProps={{ sx: { ...qrDialogPaperSx, maxWidth: { sm: 460 } } }}
    >
      <QrModalHeader
        icon={<EditIcon />}
        title="Edit Tag"
        subtitle={rowData?.tag_name || undefined}
        onClose={() => handleClose()}
      />

      <DialogContent sx={{ p: { xs: 2, sm: 3 } }}>
        <Grid container spacing={2}>
          <Grid item size={{ xs: 12, md: 12 }}>
            <FieldTextField
              name="tagName"
              label="Tag Name"
              placeholder="Enter tag name"
              required
              icon={<LocalOfferOutlinedIcon />}
              value={tagName}
              maxLength={20}
              onChange={(e) => {
                const value = e.target.value;
                if (value.startsWith(" ")) return;
                setTagName(value);
                setChangedFields((prev) => new Set(prev).add(e.target.name));
              }}
              error={!tagName.trim() && snackbar.severity === "error"}
            />
          </Grid>
        </Grid>
      </DialogContent>

      {/* Footer actions */}
      <Box sx={stepActionsSx}>
        <Stack direction="row" spacing={1.5}>
          <Button onClick={() => handleClose()} sx={backBtnSx}>Cancel</Button>
          <Button
            disabled={status2 === "loading"}
            onClick={status2 === "loading" ? null : handleSubmit}
            startIcon={status2 === "loading" ? <CircularProgress size={16} sx={{ color: "#fff" }} /> : <EditIcon />}
            sx={nextBtnSx}
          >
            {status2 === "loading" ? "Submitting.." : "Edit Tag"}
          </Button>
        </Stack>
      </Box>

      <SnackbarMessage
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
      />
    </Dialog>
  );
}
